import {v2} from "./v2";

export class MobileCard {
    //std-overlay-mobile
    constructor(element) {
        this.el = element;
        // get first div inside
        this.innerEl = this.el.querySelector('div');
        this.start = v2(0, 0);
        this.end = v2(0, 0);
        this.lastDiff = v2(0, 0);
        this.SIZE = v2(this.el.clientWidth, this.el.clientHeight);
        this.initEventHandler();
        this.PERC = 0;
    }


    touchStart(e) {
        this.start = v2(e.touches[0].clientX, e.touches[0].clientY);
        this.end = v2(e.touches[0].clientX, e.touches[0].clientY);
        let matrix = getComputedStyle(this.el).transform;
        const values = matrix.match(/matrix\((.+)\)/)[1].split(', ');
        this.lastDiff = v2(parseFloat(values[4]), parseFloat(values[5]));
    }

    touchMove(e) {
        this.end = v2(e.touches[0].clientX, e.touches[0].clientY);
        let diff = v2(this.end.x - this.start.x, this.end.y - this.start.y);
        let dx = diff.x + this.lastDiff.x;
        let dy = diff.y + this.lastDiff.y;

        dx = Math.max(dx, 0);
        dx = Math.min(dx, this.SIZE.x * 0.85);
        this.PERC = 1 - dx / this.SIZE.x;
        //dx = Math.max(Math.min(dx, W/9),50);
        this.el.style.transform = `translateX(${dx}px)`;
        this.updateInnerEl();
    }

    touchEnd(e) {
        let diff = v2(this.end.x - this.start.x, this.end.y - this.start.y);
        let dx = diff.x + this.lastDiff.x;


        if (diff.x > 0) {
            this.el.style.transform = `translateX(${this.SIZE.x * 0.94}px)`;
            this.PERC = 0;
        } else if (this.PERC > 0.5 || -diff.x > this.SIZE.x / 5) {
            this.el.style.transform = `translateX(${0}px)`;
            this.PERC = 1;
        }

        this.reset();
    }

    updateInnerEl() {
        console.log(this.innerEl, this.PERC, "PERC")
        this.innerEl.style.opacity = this.PERC;
    }

    reset() {
        this.start = v2(0, 0);
        this.end = v2(0, 0);
        this.lastDiff = v2(0, 0);
        this.updateInnerEl();
    }

    initEventHandler() {
        this.el.addEventListener('touchstart', this.touchStart.bind(this));

        this.el.addEventListener('touchmove', this.touchMove.bind(this));

        this.el.addEventListener('touchend', this.touchEnd.bind(this));
    }


}